import { jsx as c } from "../../../_virtual/jsx-runtime.mjs";
import a from "react";
import { getStatus as d } from "./common.mjs";
import { FormItemInputContext as m } from "../context/FormItemInputContext.mjs";
import "../context/ReoFormCompContext.mjs";
function S({
  children: i,
  errors: r,
  warnings: s,
  validateStatus: l,
  meta: p,
  noStyle: o
}) {
  const t = d(
    r,
    s,
    p,
    null,
    l
  ), {
    isFormItemInput: n,
    status: u
  } = a.useContext(m), f = a.useMemo(() => {
    let I;
    const e = {
      status: t || "",
      errors: r,
      warnings: s,
      feedbackIcon: I,
      isFormItemInput: !0
    };
    return o && (e.status = (t ?? u) || "", e.isFormItemInput = n), e;
  }, [
    t,
    o,
    n,
    u
  ]);
  return /* @__PURE__ */ c(m.Provider, { value: f, children: i });
}
export {
  S as default
};
//# sourceMappingURL=StatusProvider.mjs.map
